import { mediaQueries, size, colors } from '@everlywell/leaves';
import styled from 'styled-components';

interface SectionWrapperProps {
  $backgroundColor?: string;
}

export const SectionWrapper = styled.section<SectionWrapperProps>`
  padding: ${size.xl1}px ${size.lg}px;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor || colors.white};

  ${mediaQueries.forTabletVerticalDown} {
    padding: ${size.lg}px ${size.md}px;
  }
`;
